import React from "react";
import { Row, Col, Button, FormGroup, HelpBlock } from "react-bootstrap";
import ErrorList from "shared/components/ErrorList";
import OrderUnitProductInfo from "./OrderUnitProductInfo";
import OrderUnitProductCreator from "./OrderUnitProductCreator";

export default class OrderUnitWizard extends React.Component {
  constructor(props) {
    super(props);

    this.confirmLeavePageUnload = this.confirmLeavePageUnload.bind(this);
    this.confirmLeaveTurbolinks = this.confirmLeaveTurbolinks.bind(this);
  }

  componentDidMount() {
    if (window) {
      window.addEventListener("beforeunload", this.confirmLeavePageUnload);
      document.addEventListener(
        "turbolinks:before-visit",
        this.confirmLeaveTurbolinks,
      );
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener("beforeunload", this.confirmLeavePageUnload);
      document.removeEventListener(
        "turbolinks:before-visit",
        this.confirmLeaveTurbolinks,
      );
    }
  }

  addOrderUnitProduct(...args) {
    this.props.addOrderUnitProductFn(...args, this.props.allProducts);
  }

  updateOrderUnitProduct(...args) {
    this.props.updateOrderUnitProductFn(...args, this.props.allProducts);
  }

  removeOrderUnitProduct(...args) {
    this.props.removeOrderUnitProductFn(...args, this.props.allProducts);
  }

  submitOrderUnit(event) {
    event.preventDefault();

    this.props.submitOrderUnitFn(this.props.orderUnit, {
      name: this.orderUnitNameInput.value,
    });
  }

  confirmLeaveMessage() {
    // NOTE Some browsers will show prompt without message
    return (
      "Achtung: Die Bestelleinheit wurde noch nicht gespeichert. " +
      "Wenn du OK drückst gehen alle Eingaben verloren."
    );
  }

  confirmLeavePageUnload(event) {
    if (this.props.isSubmitting || this.props.submitSuccessMessage) {
      return;
    }

    /* eslint-disable no-param-reassign,consistent-return */
    event.returnValue = this.confirmLeaveMessage();
    return this.confirmLeaveMessage();
    /* eslint-enable no-param-reassign,consistent-return */
  }

  confirmLeaveTurbolinks(event) {
    if (this.props.isSubmitting || this.props.submitSuccessMessage) {
      return;
    }

    /* eslint-disable no-alert */
    if (window.confirm(this.confirmLeaveMessage())) {
      // user selected to throw away
    } else {
      event.preventDefault();
    }
    /* eslint-enable no-alert */
  }

  render() {
    const { props } = this;
    const { orderUnit, allProducts } = props;

    return (
      <div className="order-unit-details order-unit-wizard">
        <Row>
          <Col
            lg={10}
            lgOffset={1}
            md={12}
            className="order-unit-details-products"
          >
            <Row>
              <Col xs={12} md={12} className="productDetailsPanel">
                <h3 className="order-unit-title">Neue Bestelleinheit</h3>
                <div className="order-unit-info-text">
                  <p>
                    Hier kannst Du Deine Produkte der Bestelleinheit zuordnen.
                    Sollte Deine Bestelleinheit mehrere Produktsorten haben,
                    dann füge bitte die einzelnen Produksorten mit der
                    entsprechenden Anzahl hinzu. Dies gilt insbesondere bei
                    Bestelleinheiten wie Displays oder Mix-Optionen.
                  </p>
                  <p>
                    Die weiteren Informationen zu dieser Bestelleinheit, wie
                    bspw. Mindestbestellmengen und Preise, kannst Du unter
                    &quot;Details dieser Bestelleinheit&quot; angeben.
                  </p>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={8}>
                {orderUnit.orderUnitsProducts &&
                  orderUnit.orderUnitsProducts.map(
                    (orderUnitProduct, index) => {
                      const product = orderUnit.products[index];
                      return (
                        <OrderUnitProductInfo
                          key={`ouplist-${orderUnit.id}x${orderUnitProduct.productId}`}
                          orderUnit={orderUnit}
                          orderUnitProduct={orderUnitProduct}
                          product={product}
                          updateFn={this.updateOrderUnitProduct.bind(this)}
                          removeFn={this.removeOrderUnitProduct.bind(this)}
                          isSubmitting={props.isSubmitting}
                          isEditable
                        />
                      );
                    },
                  )}
                <OrderUnitProductCreator
                  orderUnit={props.orderUnit}
                  allProducts={allProducts}
                  addFn={this.addOrderUnitProduct.bind(this)}
                  isSubmitting={props.isSubmitting}
                />

                <form
                  className="order-unit-wizard-name-form"
                  onSubmit={this.submitOrderUnit.bind(this)}
                >
                  <p className="order-unit-heading">Name der Bestelleinheit*</p>
                  <FormGroup controlId="form_name">
                    <input
                      type="text"
                      required
                      className="form-control"
                      id="new-order-unit-name"
                      placeholder="Zitronenlimonade grün (24x330ml)"
                      ref={input => {
                        this.orderUnitNameInput = input;
                      }}
                    />
                    <HelpBlock>
                      Bitte Name der Bestelloption sowie in Klammern
                      &quot;Anzahl VKE x Packungsgröße&quot; angeben
                    </HelpBlock>
                  </FormGroup>

                  {!props.isSubmitting && (
                    <div>
                      <ErrorList errorMessages={props.submitErrorMessages} />

                      <Button className="btn btn-secondary" type="submit">
                        Bestelleinheit Erstellen und Weitere Details Festlegen
                      </Button>
                    </div>
                  )}
                </form>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
